/**
 * Debounced value hook — delays reflecting a fast-changing value until it
 * settles, so consumers (search boxes, filter inputs) don't fire on every
 * keystroke.
 *
 * Contains:
 * - useDebounce — returns `value`, updated `delay` ms after it stops changing
 */
import { useEffect, useState } from 'react';

/**
 * @param {*} value  the fast-changing source value
 * @param {number} delay  debounce window in ms
 * @returns {*} the debounced value
 */
export default function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
